import { HomePageItem } from '../../../components/HomePage/HomePage'
import { getResourceAddress } from './getResourceAddress'

export const getNews = async (
    windowOrigin: string
): Promise<HomePageItem[]> => {
    const resourceAddress = getResourceAddress(windowOrigin)

    const result = await fetch(
        `${resourceAddress}api/v1/news?` +
            new URLSearchParams({
                page: '1',
                limit: '12',
            }).toString(),
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )

    const news = await result.json()

    return news.items
}